import { Routes } from '@angular/router';
import { DynamicResolver } from '@finder/shared/resolvers/dynamic.resolver';
import { DynamicRouteMatcher } from '@finder/shared/route-matchers/dynamic-route.matcher';
import { ListResolver } from '@finder/shared/resolvers/list.resolver';
import { ListRouteMatcher } from '@finder/shared/route-matchers/list-route.matcher';
import { MyIdGuard } from '@finder/shared/guards/myId/myId.guard';
import { SearchResolver } from '@finder/shared/resolvers/search.resolver';
import { CalendarResolver } from '@finder/shared/resolvers/calendar.resolver';
const ɵ0 = () => import("./features/demo/demo.module.ngfactory").then(m => m.DemoModuleNgFactory), ɵ1 = () => import("./features/debug/debug.module.ngfactory").then(m => m.DebugModuleNgFactory), ɵ2 = () => import("./features/list/list.module.ngfactory").then(m => m.ListModuleNgFactory), ɵ3 = {
    pageType: 'list'
}, ɵ4 = () => import("./features/events/live.module.ngfactory").then(m => m.LiveModuleNgFactory), ɵ5 = {
    pageType: 'live'
}, ɵ6 = () => import("./features/search/search.module.ngfactory").then(m => m.SearchModuleNgFactory), ɵ7 = {
    pageType: 'search'
}, ɵ8 = () => import("./features/search/search.module.ngfactory").then(m => m.SearchModuleNgFactory), ɵ9 = {
    pageType: 'search'
}, ɵ10 = () => import("./features/calendar/calendar.module.ngfactory").then(m => m.CalendarModuleNgFactory), ɵ11 = {
    pageType: 'calendars'
}, ɵ12 = () => import("./features/list/list.module.ngfactory").then(m => m.ListModuleNgFactory), ɵ13 = {
    pageType: 'list'
}, ɵ14 = () => import("./features/dynamic-loader/dynamic-loader.module.ngfactory").then(m => m.DynamicLoaderModuleNgFactory), ɵ15 = {
    pageType: 'dynamic'
};
const routes = [
    {
        path: 'advanced-finder/demo',
        loadChildren: ɵ0,
        canActivate: [MyIdGuard]
    },
    {
        path: 'advanced-finder/debug',
        loadChildren: ɵ1,
        canActivate: [MyIdGuard]
    },
    {
        path: 'maps',
        loadChildren: ɵ2,
        pathMatch: 'full',
        data: ɵ3,
        resolve: { list: ListResolver }
    },
    {
        path: 'events',
        loadChildren: ɵ4,
        data: ɵ5,
    },
    {
        path: ':locale/search',
        loadChildren: ɵ6,
        pathMatch: 'full',
        data: ɵ7,
        resolve: { search: SearchResolver }
    },
    {
        path: 'search',
        loadChildren: ɵ8,
        pathMatch: 'full',
        data: ɵ9,
        resolve: { search: SearchResolver }
    },
    {
        path: 'calendars',
        loadChildren: ɵ10,
        data: ɵ11,
        resolve: { calendar: CalendarResolver }
    },
    {
        matcher: ListRouteMatcher,
        loadChildren: ɵ12,
        pathMatch: 'full',
        data: ɵ13,
        resolve: { list: ListResolver }
    },
    {
        matcher: DynamicRouteMatcher,
        loadChildren: ɵ14,
        data: ɵ15,
        resolve: { svc: DynamicResolver }
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15 };
